import { SearchForm } from "../Applicants/Applicants";
import styled from "@emotion/styled";
import PaymentTable from "./PaymentTable";
import { useQuery } from "@tanstack/react-query";
import apiCall from "../../../utils/apiCall";
import { AxiosError } from "axios";
import { CircularProgress } from "@mui/material";
import { DateFilter, FilterDropDown } from "../../../ui-components";
import { useState } from "react";
import {
  ExNyRoute,
} from "../../../utils/allRouteId";
import { RouteResponse } from "../../../types/index";
import { FetchAllRoutes, reOrderFetchedData } from "../../../hooks/FetchData";

interface DisplayPaymentProps {
  setRouteName: React.Dispatch<React.SetStateAction<string>>;
}

const DisplayPayment = ({ setRouteName }: DisplayPaymentProps) => {
  const [route, setRoute] = useState(Number(ExNyRoute));
  const [date, setDate] = useState({ start: "1909-08-13", end: "2100-08-13" });
  const [pageSize, setPageSize] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const [routeNameInt, setRouteNameInt] = useState("");

  const { isLoading, data } = FetchAllRoutes();

  const reOrderedAllRoutes = data
    ? reOrderFetchedData((data as RouteResponse)?.Data)
    : [];

  const allRoutes = isLoading
    ? []
    : reOrderedAllRoutes.map((item) => {
        return { name: item?.RouteName, val: item?.RouteId };
      });

  const getAllPaymentHistory = async () => {
    return (await apiCall().get(
      `Payment/GetAllPaymentMade?routeId=${route}&startDate=${date?.start}&endDate=${date?.end}&PageSize=${pageSize}&PageNumber=${currentPage}`
    )) as any;
  };

  const getAllPaymentHistoryQuery = useQuery(
    ["get-All-Payments", route, date?.start, date?.end, currentPage],
    getAllPaymentHistory,
    { retry: 0 }
  );

  const paymentHistoryData = getAllPaymentHistoryQuery?.data?.data;

  const getAllPaymentHistoryError =
    getAllPaymentHistoryQuery?.error as AxiosError;
  const getAllPaymentHistoryErrorMessage = getAllPaymentHistoryError?.message;

  const handleRouteSwitch = (route: { val: number; name: string }) => {
    setCurrentPage(1);
    setDate({ start: "1909-08-13", end: "2100-08-13" });
    setRoute(route.val);
    setRouteName(route?.name);
    setRouteNameInt(route?.name);
  };
  return (
    <>
      <TopWrapper>
        <SearchForm />
        <FilterDropDown
          onChange={handleRouteSwitch}
          options={allRoutes}
          text={routeNameInt ? `${routeNameInt}` : "Membership Route"}
          bg="#11643C"
          color="#fff"
        />
        {/* <FilterDropDown options={[{name:"Application", val: 1},{name:"Membership", val: 2}]} text="Approval Type" /> */}
        <DateFilter onChange={setDate} />
      </TopWrapper>

      {getAllPaymentHistoryQuery.isLoading ? (
        <CircularProgress
          sx={{
            fontSize: "1rem",
            marginInline: "auto",
            display: "block",
            marginBlock: "2rem",
          }}
        />
      ) : getAllPaymentHistoryQuery.isError ? (
        <StyledError>{getAllPaymentHistoryErrorMessage}</StyledError>
      ) : (
        <PaymentTable
          currentPage={currentPage}
          setCurrentPage={setCurrentPage}
          data={paymentHistoryData}
        />
      )}
    </>
  );
};

export default DisplayPayment;

const TopWrapper = styled("div")`
  display: flex;
  gap: 10px;
  align-items: center;
  margin: 10px 10px 48px 0px;
`;

const StyledError = styled("p")`
  color: red;
  font-size: 1.4rem;
  display: flex;
`;
